import React from 'react'
import Modal from 'react-bootstrap/Modal';
import { DEFAULT_CONFIRMATION_MODAL } from 'src/views/pages/text-categorization/textual-constant';
import { sanitizeHtml } from 'src/utils/custom-formatters';

export default function Confirmation({confirmationModal, setConfirmationModal}) {

  if(!confirmationModal.show) return null;
    
  return (
    <Modal className="asin_modal m-w-30" show={confirmationModal.show} onHide={() => { }}>
        <Modal.Header className='d-flex align-items-center justify-content-between py-2'>
          <Modal.Title className='f-16 f-w-600 py-1'>{confirmationModal?.modalTitle || "Message"}</Modal.Title>
            <span className="cursor-pointer f-18" onClick={() => {
                setConfirmationModal(DEFAULT_CONFIRMATION_MODAL);
                confirmationModal?.action();
                if(confirmationModal?.hideCancel) {
                    confirmationModal?.action();
                } else {
                    confirmationModal?.cancelAction();
                }
            }}>
            &#x2715;
          </span>
        </Modal.Header>

        <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
          <img src={confirmationModal.icon} alt="success" className="wid-40 mb-4" />
          <h2
            className="f-333843 f-19 f-w-600 d-flex flex-column align-items-center mb-3 text-center gap-10"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(confirmationModal.title) }}
          >
          </h2>
          <p className="f-8F8F91 f-12 f-w-400 l-20 text-center" dangerouslySetInnerHTML={{ __html: sanitizeHtml(confirmationModal.message) }}></p>
          <section className="d-flex align-items-center justify-content-center mt-4 mb-2">
            <p
              className={`bg-blue rounded-4 f-14 px-4 py-btn f-w-600 cursor-pointer text-white mt-0 mr-4  ml-3`}
              onClick={() => {
                setConfirmationModal(DEFAULT_CONFIRMATION_MODAL);
                confirmationModal.action();
              }}
            >
              {confirmationModal?.confirmButtonText || "Continue"}
            </p>
            {!confirmationModal.hideCancel && <p
              className={`cls-btn cursor-pointer rounded-4 f-14 px-4 py-btn f-w-600 mt-0 f-202226`}
              onClick={() => {
                setConfirmationModal(DEFAULT_CONFIRMATION_MODAL);
                confirmationModal.cancelAction();
              }}
            >
              {confirmationModal?.cancelButtonText || "Cancel"}
            </p>}
          </section>
        </Modal.Body>
      </Modal>
  )
}
